<h2 mat-dialog-title>
    {{'invest.saveForm.title.fullLabel' | translate}}
    <app-tooltip text="{{'invest.saveForm.title.summary' | translate}}"></app-tooltip>
</h2>

<div mat-dialog-content>
    <div class="warning" *ngIf="!hasProject"><mat-icon>warning</mat-icon>{{'invest.saveForm.warningNoProject.summary' | translate}}</div>
    <form [formGroup]="saveForm" (ngSubmit)="onSubmit()">
        <mat-form-field>
            <mat-label>{{'invest.saveForm.shortLabel.label.shortLabel' | translate}}</mat-label>
            <input type="text" matInput
                onclick="this.select()"
                formControlName="shortLabel">
            <mat-error>{{'invest.saveForm.shortLabel.errorMessage.summary' | translate}}</mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>{{'invest.saveForm.summary.label.shortLabel' | translate}}</mat-label>
            <textarea matInput formControlName="summary" rows="6"></textarea>
        </mat-form-field>
        <div class="actions">
            <button mat-raised-button color="accent" type="submit" [disabled]="saveForm.invalid">{{'invest.saveForm.submit.shortLabel' | translate}}</button>
            <button mat-button type="button" (click)="onCancel()">{{'invest.saveForm.cancel.shortLabel' | translate}}</button>
        </div>
    </form>
</div>
